import React, { useState } from 'react';
import { getDriverThread } from '../../truckmateStore';
import { shortDate } from './model';

// A driver's whole conversation with dispatch — calls, texts and their replies,
// across every load — each message tagged with the load it was about.
const clean = (t) => String(t || '').replace(/^Florida Beauty Flora dispatch: /, '').replace(/ Reply STOP to opt out\.$/, '');
const KIND = { 'confirm-stop': 'Asked to confirm delivery', 'pod-request': 'Asked for POD / BOL' };

export default function DriverThread({ phone, name }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  if (!phone) return null;
  const toggle = async () => {
    const next = !open; setOpen(next);
    if (next) { setErr(''); try { setList(await getDriverThread(phone)); } catch (e) { setErr(e.message || 'Could not load.'); setList([]); } }
  };
  return (
    <div className="tmw-thread">
      <button type="button" className="tmw-link" aria-expanded={open} onClick={toggle}>{open ? 'Hide conversation history' : `Conversation history with ${name || 'this driver'}`}</button>
      {open && (
        <div className="tmw-thread-list" aria-label={`Conversation with ${name || phone}`}>
          {err && <div className="tmw-conflict">{err}</div>}
          {list == null && <div className="tmw-note">Loading…</div>}
          {list && !list.length && !err && <div className="tmw-note">No calls or texts with this driver yet.</div>}
          {(list || []).slice().reverse().map((e, i) => (
            <div key={i} className={`tmw-msg tmw-msg-${e.type}`}>
              <div className="tmw-msg-body">
                {e.type === 'call' && e.ai ? `🤖 ${e.label || 'Jarvis (AI) call'}${e.text ? ` — ${e.text}` : ''}` : e.type === 'call' ? `📞 Called ${e.label || name || 'driver'}` : e.type === 'reply' ? clean(e.text) : (e.kind && KIND[e.kind] ? `${KIND[e.kind]}: ${clean(e.text)}` : clean(e.text))}
              </div>
              <div className="tmw-msg-meta">
                {e.trip ? <span className="tmw-msg-load">Load {e.trip}</span> : <span className="tmw-msg-load is-none">No load</span>}
                {' · '}{shortDate(Date.parse(e.at))}{e.by ? ` · ${e.by}` : e.type === 'reply' ? ` · ${name || 'driver'}` : ''}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
